const theme = {
  black: '#333333',
  white: '#ffffff', 
  primaryColor: '#2A2039',
  primaryLightColor: '#EEE6FA',
  primaryLightColorTwo: '#f8f5fd',
  secondaryColor: '#FB7B81', 
  secondaryLightColor: '#FFEBEC',
  tetriaryColor: '#E281CE',
  headingColor: '#2A2039', 
  textColor: '#7A848E',  
  shadowColor: 'rgba(0, 0, 0, 0.05)',
  shadowLightColor: '#E6E6E6',
  menuColor: '#1D316C',
  menuHoverColor: '#FB7B81'
};
export default theme;

